// import { Application } from "stimulus";
// import { definitionsFromContext } from "stimulus/webpack-helpers";

// const application = Application.start();
// const context = require.context("./controllers", true, /\.js$/);
// application.load(definitionsFromContext(context));

import { Application } from "stimulus";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

import HelloController from "./hello_controller"
application.register("hello", HelloController)

export { application }
